export namespace Cookie {
    export function get(key: string) {
        return document.cookie
            ?.split('; ')
            ?.find(cookie => cookie.startsWith(key + '='))
            ?.replace(key + '=', '')
            ?? null;
    }
    export function set(key: string, value: string, expireDays?: number, path:string = '/') {
        var expires = new Date();
        expires.setDate(expires.getDate() + (expireDays ?? 365))
        document.cookie = `${key}=${value}; expires=${expires.toString()}; path=${path}`;
    }
    export function has(key: string) {
        document.cookie
            ?.split(';')
            ?.find(cookie => cookie.startsWith(key + '=')) != null
    }
    export function getAll(key: string) {
        return document.cookie
            ?.split(';')
            ?.filter(cookie => cookie.startsWith(key + '='))
            ?.map(cookie => cookie?.replace(key + '=', ''))
            ?? []
    }
    export function remove(key: string) {
        set(key, '', -1);
    }
}
